(()=>{
const bundleComponents={"8636428189852":["8671353208988","8671353143452","8671353110684"],"9002778919068":["8671353208988","8671353143452"],"8637534568604":["8671352979612","8671353176220"],"8759323754652":["8671353012380","8671353077916","8749883457692"],"8763683864732":["8749883621532","8703923716252","8671353143452","8671353077916","8749883457692","8671353012380","8671352979612","8671353241756","8671352946844","8703934398620"],"8780017074332":["8749883555996","8671353241756","8703923716252"],"8813597720732":["8703932596380","8671353241756","8749883621532","8703923716252"],"8813600571548":["8749883555996","8703923716252","8703934398620"],"8813601128604":["8703923716252","8671353241756","8749883621532"]};
let busy=false;
const expand=cart=>new Set(cart.items.flatMap(item=>[String(item.product_id),...(bundleComponents[item.product_id]||[])]));
const sameItem=(item,key)=>item.key===key;
const hasProperties=item=>Object.keys(item.properties||{}).length>0||Boolean(item.selling_plan_allocation);
const rootRoute=()=>window.Shopify?.routes?.root||'/';
async function request(path,body){
 const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
 try{
  const response=await fetch(rootRoute()+path,{method:body?'POST':'GET',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:controller.signal,cache:'no-store'});
  if(!response.ok)throw new Error('cart_request_failed');
  return await response.json();
 }finally{clearTimeout(timer);}
}
function money(value,root){
 return new Intl.NumberFormat(document.documentElement.lang==='ar'?'ar-EG':'en-EG',{style:'currency',currency:root.dataset.currency||'EGP',maximumFractionDigits:2}).format(value/100);
}
function mount(scope=document){
 scope.querySelectorAll('[data-sfsales]').forEach(root=>{
  if(root.dataset.salesReady)return;
  root.dataset.salesReady='true';
  const strings=JSON.parse(root.querySelector('[data-sfsales-text]').textContent);
  const status=root.querySelector('[data-sfsales-status]');
  const cards=[...root.querySelectorAll('[data-sfsales-card]')];
  const isCart=root.dataset.cartContext==='true';
  function sync(card){
   const select=card.querySelector('[data-sfsales-variant]');
   if(select&&select.value){const price=Number(select.selectedOptions[0].dataset.price);card.querySelector('[data-sfsales-price]').textContent=money(price,root);const delta=card.querySelector('[data-sfsales-difference]');if(delta){const difference=price-Number(card.dataset.sourcePrice);delta.hidden=difference<=0;delta.textContent=strings.difference+' '+money(difference,root);}}
   const button=card.querySelector('[data-sfsales-submit]');button.disabled=busy||Boolean(select&&!select.value);
  }
  function setStatus(text,cartLink=false){
   status.textContent=text;
   if(cartLink){const a=document.createElement('a');a.href=root.dataset.cartUrl;a.textContent=' '+strings.review_cart;status.append(a);}
  }
  cards.forEach(card=>{
   const form=card.querySelector('[data-sfsales-form]');
   const button=form.querySelector('[data-sfsales-submit]'),label=button.textContent;
   sync(card);
   form.querySelector('[data-sfsales-variant]')?.addEventListener('change',()=>{sync(card);setStatus('');});
   form.addEventListener('submit',async event=>{
    event.preventDefault();event.stopPropagation();
    if(busy||!form.reportValidity())return;
    const variantId=Number(new FormData(form).get('id'));if(!variantId)return;
    busy=true;document.querySelectorAll('[data-sfsales-submit]').forEach(b=>{b.disabled=true;});button.textContent=strings.adding;setStatus('');
    let added=false;
    try{
     const cart=await request('cart.js');
     const upgrading=isCart&&card.dataset.kind==='upgrade';
     let source;
     if(upgrading){
      source=cart.items.find(item=>sameItem(item,card.dataset.sourceKey));
      if(!source||hasProperties(source)||source.quantity<1){setStatus(strings.changed,true);return;}
     }
     const occupied=expand(upgrading?{items:cart.items.filter(item=>!sameItem(item,source.key))}:cart);
     const components=card.dataset.components.split(',').filter(Boolean);
     if(occupied.has(card.dataset.productId)||components.some(id=>occupied.has(id))){setStatus(strings.in_cart,true);return;}
     await request('cart/add.js',{items:[{id:variantId,quantity:1}]});added=true;
     if(upgrading){
      const current=await request('cart.js');
      const remaining=current.items.find(item=>sameItem(item,source.key));
      if(remaining)await request('cart/change.js',{id:remaining.key,quantity:Math.max(0,remaining.quantity-1)});
     }
     window.location.assign(root.dataset.cartUrl);
    }catch(error){setStatus(added?strings.partial:strings.error,added);}
    finally{
     busy=false;button.textContent=label;
     document.querySelectorAll('[data-sfsales-card]').forEach(c=>{const b=c.querySelector('[data-sfsales-submit]'),s=c.querySelector('[data-sfsales-variant]');b.disabled=Boolean(s&&!s.value);});
    }
   });
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
